var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-app',{attrs:{"label":_vm.title}},[_c('v-container',{attrs:{"fluid":""}},[_c('user-usage')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }